import { useQuery } from "@tanstack/react-query";
import {
  abbreviationsService,
  ActiveAbbreviation,
} from "../services/admin/abbreviations.service";

export function useActiveAbbreviations() {
  const { data, isLoading } = useQuery<ActiveAbbreviation[]>({
    queryKey: ["abbreviations"],
    queryFn: () => abbreviationsService.getActive(),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });

  return {
    abbreviations: data ?? [],
    isLoading,
  };
}
